import { ArrowUpRight, InstagramLogo, TiktokLogo, YoutubeLogo, FacebookLogo, WhatsappLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { useLang } from "../../i18n";
import Chapter from "./Chapter";
import Reveal from "./Reveal";

export default function Gabung({ settings }) {
    const { t } = useLang();
    const socials = [
        { key: "instagram", label: "Instagram", icon: InstagramLogo },
        { key: "tiktok", label: "TikTok", icon: TiktokLogo },
        { key: "youtube", label: "YouTube", icon: YoutubeLogo },
        { key: "facebook", label: "Facebook", icon: FacebookLogo },
    ].filter((s) => settings[s.key]);

    return (
        <section id="gabung" className="py-24 md:py-32 border-t border-racing-line" data-testid="gabung-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <Chapter number="10" title={t.ch_gabung_t} subtitle={t.ch_gabung_s} />

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20">
                    <Reveal>
                        <h3 className="font-display uppercase text-3xl md:text-5xl leading-[1.05] text-neutral-900">
                            {t.gabung_heading_1} <span className="text-racing-red">{t.gabung_heading_2}</span>
                        </h3>
                        <p className="mt-6 text-base font-light text-racing-muted leading-relaxed max-w-md">
                            {t.gabung_desc}
                        </p>
                        <div className="mt-10 flex flex-wrap gap-4">
                            <a
                                href="/daftar-siswa-baru"
                                data-testid="gabung-new-student-button"
                                className="bg-racing-red hover:bg-racing-redhover text-white text-xs uppercase tracking-[0.25em] px-8 py-4 transition-colors duration-300"
                            >
                                {t.nav_new_student}
                            </a>
                            {settings.whatsapp && (
                                <a
                                    href={settings.whatsapp}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="gabung-whatsapp-button"
                                    className="flex items-center gap-3 border border-black/30 hover:border-white text-neutral-900 text-xs uppercase tracking-[0.25em] px-8 py-4 transition-colors duration-300"
                                >
                                    <WhatsappLogo size={18} weight="fill" />
                                    WhatsApp
                                </a>
                            )}
                        </div>
                    </Reveal>

                    <Reveal delay={0.15}>
                        <p className="text-xs uppercase tracking-[0.25em] text-racing-muted mb-4">{t.gabung_follow}</p>
                        <div className="border-t border-racing-line">
                            {socials.map((s) => (
                                <a
                                    key={s.key}
                                    href={settings[s.key]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`social-link-${s.key}`}
                                    className="group flex items-center justify-between py-5 border-b border-racing-line hover:bg-black/[0.03] transition-colors duration-300 px-2 -mx-2"
                                >
                                    <span className="flex items-center gap-4">
                                        <s.icon size={26} weight="duotone" className="text-racing-red" />
                                        <span className="font-display uppercase text-xl md:text-2xl text-neutral-900/90 group-hover:text-racing-red transition-colors duration-300">
                                            {s.label}
                                        </span>
                                    </span>
                                    <ArrowUpRight size={20} weight="bold" className="text-racing-muted group-hover:text-racing-red transition-colors duration-300" />
                                </a>
                            ))}
                            {settings.email && (
                                <a
                                    href={`mailto:${settings.email}`}
                                    data-testid="social-link-email"
                                    className="group flex items-center justify-between py-5 border-b border-racing-line hover:bg-black/[0.03] transition-colors duration-300 px-2 -mx-2"
                                >
                                    <span className="flex items-center gap-4">
                                        <EnvelopeSimple size={26} weight="duotone" className="text-racing-red" />
                                        <span className="font-display uppercase text-xl md:text-2xl text-neutral-900/90 group-hover:text-racing-red transition-colors duration-300">
                                            {settings.email}
                                        </span>
                                    </span>
                                    <ArrowUpRight size={20} weight="bold" className="text-racing-muted group-hover:text-racing-red transition-colors duration-300" />
                                </a>
                            )}
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
